import React, { useState } from 'react';

const BRAND = '#0f6e56';

// Generate a professional PDF document (invoice / receipt / quotation)
function generateDocPDF(docType, data) {
  const win = window.open('', '_blank');
  if (!win) { alert('Please allow pop-ups to download the PDF'); return; }
  const fmt = n => (data.currency || '$') + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const subtotal = data.items.reduce((s, i) => s + (Number(i.qty) || 0) * (Number(i.rate) || 0), 0);
  const taxAmt = subtotal * ((Number(data.taxPercent) || 0) / 100);
  const total = subtotal + taxAmt;

  const titles = { invoice: 'INVOICE', receipt: 'RECEIPT', quotation: 'QUOTATION' };
  const rows = data.items.map(i => `<tr>
    <td>${i.description || ''}</td>
    <td class="num">${i.qty || 0}</td>
    <td class="num">${fmt(i.rate)}</td>
    <td class="num">${fmt((Number(i.qty) || 0) * (Number(i.rate) || 0))}</td>
  </tr>`).join('');

  win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${titles[docType]} ${data.docNumber}</title>
  <style>
    *{margin:0;padding:0;box-sizing:border-box}
    body{font-family:Arial,Helvetica,sans-serif;padding:48px;color:#222;max-width:800px;margin:0 auto}
    .top{display:flex;justify-content:space-between;margin-bottom:36px}
    .biz-name{font-size:24px;font-weight:700;color:${BRAND};font-family:Georgia,serif}
    .biz-detail{font-size:12px;color:#666;margin-top:4px;line-height:1.6}
    .doc-title{font-size:32px;font-weight:700;color:${BRAND};text-align:right;letter-spacing:1px}
    .doc-meta{font-size:12px;color:#666;text-align:right;margin-top:6px;line-height:1.7}
    .parties{display:flex;justify-content:space-between;margin-bottom:28px;padding:16px 0;border-top:1px solid #eee;border-bottom:1px solid #eee}
    .label{font-size:10px;color:#999;text-transform:uppercase;letter-spacing:1px;margin-bottom:4px}
    .party-name{font-size:15px;font-weight:600}
    .party-detail{font-size:12px;color:#666;line-height:1.6}
    table{width:100%;border-collapse:collapse;margin-bottom:20px}
    th{background:${BRAND};color:#fff;padding:11px 14px;text-align:left;font-size:12px;text-transform:uppercase;letter-spacing:0.3px}
    th.num,td.num{text-align:right}
    td{padding:11px 14px;border-bottom:1px solid #f0f0f0;font-size:13px}
    .totals{margin-left:auto;width:280px}
    .totals tr td{border:none;padding:6px 14px}
    .totals .grand td{border-top:2px solid ${BRAND};font-weight:700;font-size:16px;color:${BRAND};padding-top:10px}
    .notes{margin-top:30px;padding:16px;background:#f7f8fa;border-radius:8px;font-size:12px;color:#666}
    .footer{margin-top:40px;text-align:center;color:#aaa;font-size:11px;border-top:1px solid #eee;padding-top:16px}
    .paid-stamp{display:inline-block;margin-top:10px;padding:6px 16px;border:2px solid ${BRAND};color:${BRAND};border-radius:6px;font-weight:700;transform:rotate(-3deg)}
    @media print{body{padding:24px}.no-print{display:none}}
  </style></head><body>
    <div class="top">
      <div>
        <div class="biz-name">${data.bizName || 'Your Business'}</div>
        <div class="biz-detail">${data.bizAddress || ''}<br>${data.bizPhone || ''}${data.bizEmail ? ' · ' + data.bizEmail : ''}</div>
      </div>
      <div>
        <div class="doc-title">${titles[docType]}</div>
        <div class="doc-meta">No: ${data.docNumber || '—'}<br>Date: ${data.date || ''}${data.dueDate ? '<br>Due: ' + data.dueDate : ''}</div>
        ${docType === 'receipt' ? '<div class="paid-stamp">PAID</div>' : ''}
      </div>
    </div>
    <div class="parties">
      <div>
        <div class="label">${docType === 'quotation' ? 'Quotation For' : 'Bill To'}</div>
        <div class="party-name">${data.clientName || ''}</div>
        <div class="party-detail">${data.clientAddress || ''}<br>${data.clientPhone || ''}${data.clientEmail ? ' · ' + data.clientEmail : ''}</div>
      </div>
    </div>
    <table>
      <thead><tr><th>Description</th><th class="num">Qty</th><th class="num">Rate</th><th class="num">Amount</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
    <table class="totals">
      <tr><td>Subtotal</td><td class="num">${fmt(subtotal)}</td></tr>
      ${data.taxPercent ? `<tr><td>Tax (${data.taxPercent}%)</td><td class="num">${fmt(taxAmt)}</td></tr>` : ''}
      <tr class="grand"><td>Total</td><td class="num">${fmt(total)}</td></tr>
    </table>
    ${data.notes ? `<div class="notes"><strong>Notes:</strong> ${data.notes}</div>` : ''}
    <div class="footer">Created free with FinlyBooks · Track. Manage. Grow. · www.finlybooks.com</div>
    <div class="no-print" style="text-align:center;margin-top:24px">
      <button onclick="window.print()" style="padding:12px 28px;background:${BRAND};color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer">🖨️ Download / Print PDF</button>
    </div>
  </body></html>`);
  win.document.close();
}

export default function FreeTools({ onGetStarted }) {
  const [tool, setTool] = useState('invoice');
  const [data, setData] = useState({
    bizName: '', bizAddress: '', bizPhone: '', bizEmail: '',
    clientName: '', clientAddress: '', clientPhone: '', clientEmail: '',
    docNumber: 'INV-0001', date: new Date().toISOString().slice(0, 10), dueDate: '',
    currency: '$', taxPercent: '', notes: '',
    items: [{ description: '', qty: 1, rate: '' }],
  });

  const upd = (k, v) => setData(d => ({ ...d, [k]: v }));
  const updItem = (idx, k, v) => setData(d => ({ ...d, items: d.items.map((it, i) => i === idx ? { ...it, [k]: v } : it) }));
  const addItem = () => setData(d => ({ ...d, items: [...d.items, { description: '', qty: 1, rate: '' }] }));
  const delItem = (idx) => setData(d => ({ ...d, items: d.items.filter((_, i) => i !== idx) }));

  const tools = {
    invoice: { label: 'Invoice', icon: '📄', prefix: 'INV', desc: 'Professional invoices for your customers' },
    receipt: { label: 'Receipt', icon: '🧾', prefix: 'RCP', desc: 'Payment receipts marked as paid' },
    quotation: { label: 'Quotation', icon: '📋', prefix: 'QUO', desc: 'Price estimates and quotes' },
  };

  const subtotal = data.items.reduce((s, i) => s + (Number(i.qty) || 0) * (Number(i.rate) || 0), 0);
  const taxAmt = subtotal * ((Number(data.taxPercent) || 0) / 100);
  const total = subtotal + taxAmt;
  const fmt = n => (data.currency || '$') + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <div style={{ minHeight: '100vh', background: '#f7f8fa' }}>
      <div style={{ background: BRAND, padding: '0 32px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ color: '#fff', fontSize: 20, fontWeight: 700, fontFamily: 'Georgia, serif' }}>FinlyBooks <span style={{ fontSize: 12, opacity: 0.6, fontFamily: 'Arial' }}>Free Tools</span></div>
        <button onClick={onGetStarted} style={{ background: '#fff', color: BRAND, border: 'none', padding: '8px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>Get the full app free →</button>
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: 32 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h1 style={{ fontSize: 30, fontWeight: 700, color: '#222', marginBottom: 8 }}>Free Invoice, Receipt & Quotation Maker</h1>
          <p style={{ fontSize: 15, color: '#666' }}>Create professional documents in seconds. No signup, no watermark, 100% free.</p>
        </div>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginBottom: 28 }}>
          {Object.entries(tools).map(([k, t]) => (
            <button key={k} onClick={() => { setTool(k); upd('docNumber', t.prefix + '-0001'); }} style={{
              padding: '14px 28px', borderRadius: 12, border: `2px solid ${tool === k ? BRAND : '#e0e0e0'}`,
              background: tool === k ? BRAND : '#fff', color: tool === k ? '#fff' : '#555',
              cursor: 'pointer', fontSize: 15, fontWeight: 600, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, minWidth: 130
            }}>
              <span style={{ fontSize: 24 }}>{t.icon}</span>
              {t.label}
            </button>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 380px', gap: 24, alignItems: 'start' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 28, border: '1px solid #e8e8e8' }}>
            <Section title="Your Business">
              <Row><Inp label="Business name" value={data.bizName} onChange={v => upd('bizName', v)} placeholder="Your Business Ltd" /></Row>
              <Row><Inp label="Address" value={data.bizAddress} onChange={v => upd('bizAddress', v)} placeholder="Street, City" /></Row>
              <Row>
                <Inp label="Phone" value={data.bizPhone} onChange={v => upd('bizPhone', v)} placeholder="+1 555 000 0000" />
                <Inp label="Email" value={data.bizEmail} onChange={v => upd('bizEmail', v)} placeholder="you@business.com" />
              </Row>
            </Section>

            <Section title={tool === 'quotation' ? 'Quotation For' : 'Bill To'}>
              <Row><Inp label="Client name" value={data.clientName} onChange={v => upd('clientName', v)} placeholder="Client name" /></Row>
              <Row><Inp label="Address" value={data.clientAddress} onChange={v => upd('clientAddress', v)} placeholder="Client address" /></Row>
              <Row>
                <Inp label="Phone" value={data.clientPhone} onChange={v => upd('clientPhone', v)} placeholder="Phone" />
                <Inp label="Email" value={data.clientEmail} onChange={v => upd('clientEmail', v)} placeholder="Email" />
              </Row>
            </Section>

            <Section title="Document Details">
              <Row>
                <Inp label="Number" value={data.docNumber} onChange={v => upd('docNumber', v)} />
                <Inp label="Date" type="date" value={data.date} onChange={v => upd('date', v)} />
                {tool !== 'receipt' && <Inp label="Due date" type="date" value={data.dueDate} onChange={v => upd('dueDate', v)} />}
              </Row>
            </Section>

            <Section title="Items">
              {data.items.map((it, i) => (
                <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 70px 90px 32px', gap: 8, marginBottom: 8, alignItems: 'center' }}>
                  <input value={it.description} onChange={e => updItem(i, 'description', e.target.value)} placeholder="Description" style={inp} />
                  <input type="number" value={it.qty} onChange={e => updItem(i, 'qty', e.target.value)} placeholder="Qty" style={inp} />
                  <input type="number" value={it.rate} onChange={e => updItem(i, 'rate', e.target.value)} placeholder="Rate" style={inp} />
                  <button onClick={() => delItem(i)} style={{ background: 'none', border: 'none', color: '#e24b4a', cursor: 'pointer', fontSize: 16 }}>×</button>
                </div>
              ))}
              <button onClick={addItem} style={{ background: '#e1f5ee', color: BRAND, border: 'none', padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>+ Add item</button>
            </Section>

            <Section title="Extras">
              <Row>
                <div style={{ flex: 1 }}>
                  <label style={lbl}>Currency</label>
                  <select value={data.currency} onChange={e => upd('currency', e.target.value)} style={inp}>
                    {['$', '£', '€', '₹', 'AED', 'JMD'].map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <Inp label="Tax %" type="number" value={data.taxPercent} onChange={v => upd('taxPercent', v)} placeholder="0" />
              </Row>
              <Row><Inp label="Notes" value={data.notes} onChange={v => upd('notes', v)} placeholder="Thank you for your business!" /></Row>
            </Section>
          </div>

          <div style={{ position: 'sticky', top: 24 }}>
            <div style={{ background: '#fff', borderRadius: 16, padding: 24, border: '1px solid #e8e8e8', marginBottom: 16 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#888', marginBottom: 16, textTransform: 'uppercase', letterSpacing: 0.5 }}>Live Preview</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: BRAND, fontFamily: 'Georgia, serif' }}>{tools[tool].label.toUpperCase()}</div>
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{data.docNumber} · {data.date}</div>
              <div style={{ borderTop: '1px solid #eee', borderBottom: '1px solid #eee', padding: '12px 0', margin: '14px 0' }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{data.bizName || 'Your Business'}</div>
                <div style={{ fontSize: 11, color: '#888', marginTop: 6 }}>To: {data.clientName || 'Client'}</div>
              </div>
              {data.items.filter(i => i.description).map((it, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 6 }}>
                  <span style={{ color: '#666' }}>{it.description} ×{it.qty}</span>
                  <span style={{ fontWeight: 500 }}>{fmt((Number(it.qty) || 0) * (Number(it.rate) || 0))}</span>
                </div>
              ))}
              <div style={{ borderTop: '2px solid ' + BRAND, marginTop: 12, paddingTop: 10, display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontWeight: 700, color: BRAND }}>Total</span>
                <span style={{ fontWeight: 700, color: BRAND, fontSize: 18 }}>{fmt(total)}</span>
              </div>
            </div>
            <button onClick={() => generateDocPDF(tool, data)} style={{ width: '100%', padding: 16, background: BRAND, color: '#fff', border: 'none', borderRadius: 12, fontSize: 16, fontWeight: 700, cursor: 'pointer', marginBottom: 12 }}>
              ⬇ Download {tools[tool].label} PDF
            </button>
            <div style={{ background: '#e1f5ee', borderRadius: 12, padding: 16, textAlign: 'center' }}>
              <div style={{ fontSize: 13, color: '#085041', marginBottom: 8 }}>Want to <strong>save & track</strong> all your documents?</div>
              <button onClick={onGetStarted} style={{ background: BRAND, color: '#fff', border: 'none', padding: '8px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>Get FinlyBooks free →</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: BRAND, marginBottom: 12, textTransform: 'uppercase', letterSpacing: 0.5 }}>{title}</div>
      {children}
    </div>
  );
}
function Row({ children }) { return <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>{children}</div>; }
function Inp({ label, type = 'text', value, onChange, placeholder }) {
  return (
    <div style={{ flex: 1 }}>
      <label style={lbl}>{label}</label>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} style={inp} />
    </div>
  );
}
const lbl = { display: 'block', fontSize: 12, color: '#888', marginBottom: 4 };
const inp = { width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13, color: '#222', outline: 'none', boxSizing: 'border-box' };
